import React from 'react';
import PropTypes from 'prop-types';
import { Field, propTypes, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import compose from 'recompose/compose';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { translate } from 'ra-core';
import registrationSubmit from './registrationSubmit';

const styles = () => ({
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        marginTop: '1em',
    },
    button: {
        width: '100%',
        backgroundColor: '#e01722'
    },
});

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
    meta: { touched, error } = {}, // eslint-disable-line react/prop-types
    input: { ...inputProps }, // eslint-disable-line react/prop-types
    ...props
}) => (
    <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />
);

//const login = (auth, dispatch, { redirectTo }) =>
//    dispatch(userLogin(auth, redirectTo));

const LoginLink = props => <Link to="/login" {...props} />

const RegistrationForm = ({ classes, isLoading, handleSubmit, translate }) => (
    <form onSubmit={handleSubmit(registrationSubmit)}>
        <div className={classes.form}>
            <div className={classes.input}>
                <Field
                    id="username"
                    name="username"
                    component={renderInput}
                    label={'Username'}
                    disabled={isLoading}
                />
            </div>
            <div className={classes.input}>
                <Field
                    id="first_name"
                    name="firstName"
                    component={renderInput}
                    label={'First Name'}
                    disabled={isLoading}
                />
            </div>
            <div className={classes.input}>
                <Field
                    id="last_name"
                    name="lastName"
                    component={renderInput}
                    label={'Last Name'}
                    disabled={isLoading}
                />
            </div>
            <div className={classes.input}>
                <Field
                    id="email"
                    name="email"
                    component={renderInput}
                    label={'Email'}
                    disabled={isLoading}
                />
            </div>
            <div className={classes.input}>
                <Field
                    id="password"
                    name="password"
                    component={renderInput}
                    label={'Password'}
                    type="password"
                    disabled={isLoading}
                />
            </div>
            <div className={classes.input}>
                <Field
                    id="confirm_password"
                    name="confirmPassword"
                    component={renderInput}
                    label={'Confirm Password'}
                    type="password"
                    disabled={isLoading}
                />
            </div>
        </div>
        <CardActions>
            <Button
                type="submit"
                variant="raised"
                color="secondary"
                disabled={isLoading}
                className={classes.button}
            >
                {isLoading && <CircularProgress size={25} thickness={2} />}
                {'Register'}
            </Button>
        </CardActions>
        <CardActions>
            <Button
                component={LoginLink}
                variant="raised"
                color="secondary"
                className={classes.button}
            >
                {}
                {'Back to Sign-in'}
            </Button>
        </CardActions>
    </form>
);

RegistrationForm.propTypes = {
    ...propTypes,
    classes: PropTypes.object,
    redirectTo: PropTypes.string
};

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 });

const enhance = compose(
    withStyles(styles),
    translate,
    connect(mapStateToProps),
    reduxForm({
        form: 'register',
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;
            if (!values.username)
                errors.username = translate('ra.validation.required');
            if (!values.firstName)
                errors.firstName = translate('ra.validation.required');
            if (!values.lastName)
                errors.lastName = translate('ra.validation.required');
            if (!values.email)
                errors.email = translate('ra.validation.required');
            if (!values.password)
                errors.password = translate('ra.validation.required');
            if (!values.confirmPassword)
                errors.confirmPassword = translate('ra.validation.required');
            if (values.password !== values.confirmPassword) {
                errors.password = 'These values do no match';
                errors.confirmPassword = 'These values do no match';
            }

            return errors;
        },
    })
);

export default enhance(RegistrationForm);
